import { apiClient } from '../api-client';

/**
 * Shape returned by /api/v1/platform/api-clients. Mirrors the runtime's
 * FeApiClient presenter (we only consume the fields Engage actually
 * renders; admin-only fields like tenantId/tenantName are omitted
 * because tenant-admins are always within their own tenant context).
 *
 * Tier values come back UPPERCASE from the runtime ('PORTAL',
 * 'INTEGRATION', …). The Engage UI normalizes for display via
 * `formatTier()` but does NOT rewrite the wire shape.
 */
export interface PlatformApiClient {
  id: string;
  name: string;
  purpose:
    | 'inventory_sync'
    | 'order_sync'
    | 'dispatch_integration'
    | 'reporting'
    | 'webhook_consumer'
    | 'custom';
  systemRef?: string;
  description?: string;
  status: 'active' | 'inactive';
  tier?: 'PLATFORM_ADMIN' | 'TENANT_ADMIN' | 'INTEGRATION' | 'PORTAL';
  keyCount?: number;
  lastUsedAt?: string;
  createdAt: string;
  updatedAt?: string;
}

interface ListResponse {
  success?: boolean;
  data: PlatformApiClient[] | { items: PlatformApiClient[]; total?: number };
}

export async function listApiClients(): Promise<PlatformApiClient[]> {
  const { data } = await apiClient.get<ListResponse>('/platform/api-clients');
  // Runtime sometimes wraps in { data: { items, total } } (paginated) and
  // sometimes returns a bare array. Normalize both.
  const payload = data.data;
  if (Array.isArray(payload)) return payload;
  return payload?.items ?? [];
}
